import { APIcaller } from './APIcaller';
import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';

const getTasks = (taskNames, startDate, endDate, skip, limit) =>
  APIcaller.apiPost(`/backoffice/tasks/list`, {
    taskNames,
    startDate: startDate.format(
      DATE_DISPLAY_FORMATS.HYPHEN_YEAR_MONTH_DAY_HOUR_MINUTE_SECOND_TIMEZONE,
    ),
    endDate: endDate.format(DATE_DISPLAY_FORMATS.HYPHEN_YEAR_MONTH_DAY_HOUR_MINUTE_SECOND_TIMEZONE),
  });

export const stopTask = (taskId) => APIcaller.apiPost(`/backoffice/tasks/${taskId}/stop`);

export const taskService = {
  getTasks,
  stopTask,
};
